const Config = {
    apiUrl: process.env.REACT_APP_API_URL,
    stAppVersion: '1.0.0'
}

export default Config